module.exports = __webpack_public_path__ + "static/media/1-12things-print-title.5a6f50b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/1-12things-print-title.jpg
// module id = 137
// module chunks = 0